import React from 'react';
import { Paper, Typography } from '@mui/material';

interface CardStatWidgetProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const CardStatWidget: React.FC<CardStatWidgetProps> = ({ icon, title, description }) => {
  return (
    <Paper
      elevation={1}
      sx={{
        textAlign: 'center',
        p: 4,
        borderRadius: 3,
        '&:hover': {
          boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
          transform: 'translateY(-4px)',
          transition: 'all 0.3s ease-in-out',
        },
      }}
    >
      {icon}
      <Typography variant="h6" fontWeight="bold" gutterBottom mt={2}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </Paper>
  );
};

export default CardStatWidget;
